/* eslint-disable */
export default {
  status: '状态',
  acceptQueueCalls: '接听通话队列呼叫',
  callQueueDisabledReason: '此设置由您公司的管理员管理。',
  callQueueManagement: '管理队列',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
